// extracted by mini-css-extract-plugin
export var fullHeightState = "_a-7";
export var headerCell = "_a-1";
export var loadingStateCell = "_a-4";
export var rowWrapper = "_a-3";
export var standaloneTable = "_a-8";
export var standaloneTableWithBodyFill = "_a-9";
export var stateCell = "_a-5";
export var table = "_a-0";
export var tableBodyFiller = "_a-6";
export var white = "_a-2";